<template>
    <div class="no-result">
        <dl class="empty_content">
            <dt>
                <img :src="require('@/assets/images/icon-empty-content@2x.png')" alt="" />
            </dt>
            <dd>
                <p class="no-result-text">{{title}}</p>
            </dd>
        </dl>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        iconClass: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
.no-result {
    text-align: center
}


.empty_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding-bottom: 100px;

    >dt {
        width: 79px;
        height: 52px;
        margin-top: 60px;

        >img {
            width: 100%;
            height: 100%;
        }
    }

    >dd {
        margin-top: 24px;
        font-size: 13px;
        color: #939393;
    }
}

.no-result-icon {
    width: 86px;
    height: 90px;
    margin: 0 auto;
    background: url(no-merchant.png) no-repeat;
    background-size: 86px 90px;

    &.parking {
        background: url(no-parking.png) no-repeat;
        width: 101px;
        height: 65px;
        background-size: contain;
    }
}

.album .no-result-icon {
    width: 78px;
    height: 78px;
    background-size: contain;
}

.no-result-text {
    // font-size: 16px;
    color: #999;
}
</style>